module.exports = __webpack_public_path__ + "static/media/Privacy-4.69e222da.png";